import 'moment/locale/lv.js';
import { ITranslationForMts } from './translationInterface';

export const lvLVForMts: ITranslationForMts = {
    route_PrematchHome: 'lv',
    route_TopBetsMobile: 'top',
    route_HomeTopBetsDesktop: 'most-popular',
    route_HomeLiveDesktop: 'live',
    route_HomeHotBetsDesktop: 'hotbets',
    route_HomeTicketOfDayDesktop: 'bet-of-the-day',
    route_HomeTopOfferDesktop: 'top-offer',
    route_SportsList: 'sports',
    route_StandardEvents: 'events',
    route_StandardEventDetail: 'event',
    route_LiveEvents: 'live-events',
    route_LiveEventDetail: 'live-event',
    route_CashOut: 'cashout',
    route_BetDetail: 'my-betslip',
    route_BetDetailPublic: 'betslip',
    route_LegacyTicketDetailPublic: "betslipl",
    route_BetList: 'my-betslips',
    route_BetListVG: 'my-betslips-vg',
    route_BetWinList: 'my-wins',
    route_Search: 'search',
    route_MarketingAction: 'competitions',
    route_TicketDetail: 'my-betslip',
    route_TicketDetailVG: 'my-betslip-vg',
    route_TicketDetailByNumber: 'find-betslip',
    route_Calendar: 'calendar',
    route_Favorites: 'favorites',
    route_Top5Bets: '',
    route_Top10Bets: '',
    //
    no_categories: 'Nav kategoriju.',
    today: 'Šodien',
    tomorrow: 'Rīt',
    yesterday: 'Vakar',
    weekend: 'Nedēļas nogale',
    todayTomorrow: 'Šodien, Rīt ',
    by_date: 'Pēc datuma',
    by_time: 'Pēc laika',
    by_week_day: 'Pēc dienas',
    hour: 'stunda',
    three_hours: '3 stundas',
    hours: 'stundas',
    more: 'Vairāk',
    available_tips: 'Izvēle',
    date: 'Datums',
    game: 'Spēle',
    deposit: 'Iemaksa:',
    eventual_winnings: 'Iespējamie laimesti:',
    detail: 'Sīkāk',
    other: 'Citi',
    less: 'Mazāk',
    all: 'Viss',
    result: 'Rezultāts',
    statistics: 'Statistika',
    search: 'Meklēt …',
    no_results: 'Nav rezultāta',
    detail_not_found: 'Informācija nav atrasta',
    back: 'Atpakaļ',
    next: "Nākošais",
    final_rate: 'Gala koeficients:',
    finished: 'Noslēdzies',
    match: 'Mačs',
    bet: 'Likme',
    rate: 'Koeficients',
    ticket_code: 'Kupona kods',
    state: 'Statuss',
    date_paid: 'Apmaksas datums',
    stake: 'Likme',
    eventual_win: 'Iespējamais laimests',
    ticket_type: 'Kupona tips',
    bet_type: 'Likmes tips',
    channel: 'kanāls',
    ticket_detail: 'Kupona detaļas',
    prize_paid: 'Izmaksātais laimests',
    win_paid: 'Tiks izmaksāts',
    ticket_public_link: 'Kupona publiskā saite:',
    refresh: 'Atjaunināt',
    download_file: 'Lejupielādēt failu',
    combination: 'kombinācija',
    combinations_0: 'kombinācijas',
    combinations_few: 'kombinācijas',
    combinations_more: 'kombinācijas',
    combination_short: 'komb.',
    event_no_longer_available: 'Notikums vairs nav aktīvs.',
    has_to_be_logged_in: 'Ielogojies, lai izvēlētos kategoriju.',
    something_went_wrong: 'Kaut kas nogāja greizi.',
    no_events_for_filter: "Nav notikumu, kas atbilst izvēlētajam filtram.",
    no_events_or_leagues_found: "Nav notikumu vai līgu, kas atbilst izvēlētajam filtram.",
    flag_new: "new",

    // --------------------- general
    general_BtnMore: "Vairāk",
    general_Loading: 'Ielādē...',
    general_OddsDraw: "Neizšķirts",
    general_EventGameGroupOther: "Citi",
    general_EventLiveTag: "LIVE",
    general_CriticalRenderError: 'Kļūda',
    general_CriticalRenderRefreshBtn: 'Turpināt',
    general_CriticalRenderHomeBtn: 'Sākuma lapa',
    general_ProgressContentError: 'Ielādes kļūda, lūdzu mēģini vēlreiz.',
    general_ErrorInInitialization: 'Inicializācijas kļūda',
    general_SessionExpired: 'Sesijas laiks ir beidzies',

    // ---------------------- menu
    menu_Top: "Top",
    menu_Prematch: "Sports",
    menu_Live: "LIVE",
    menu_Cashout: "CASHOUT",
    menu_Search: "Meklēt",
    menu_Time: 'Laiks',

    // --------------------- live-menu
    liveMenu_overview: "Notikumu pārskats",
    liveMenu_favourites: "Favorīti",
    liveMenu_event: "Viens notikums",
    liveMenu_calendar: "Notikumu kalendārs",

    //------------------- topBets
    topbets_TopBetsTitle: "Populārākās spēles",
    topbets_HotBetsTitle: "Paaugstināti koeficienti",
    topbets_NoResults: "Saraksts ir tukšs",
    topbets_Top5Title: "TOP 5",
    topbets_Top10Title: "TOP 10",

    //  ---------------------- prematch
    prematch_NoEventsForFilter: "Nav notikumu pēc izvēlētā filtra.",
    prematch_SportListTitle: "SPORTA VEIDI",
    prematch_SportListNoSport: "Nav notikumu pēc izvēlētā laika intervāla.",
    prematch_TimeFilterAll: "Viss",
    prematch_TimeFilterToday: "Šodien",
    prematch_TimeFilterTodayTomorrow: "Šodien un Rīt",
    prematch_TimeFilterWeek: "Nedēļa",
    prematch_TabOdds: "Koeficienti",
    prematch_TabStats: "Statistika",
    prematch_EventNotExists: "Notikums vairs nav pieejams.",
    prematch_EventListSectionTop: "TOP",
    prematch_EventListSectionOthers: "Citi",
    prematch_MobileExpandMoreVMT: "+ Vairāk",
    prematch_MobileCollapseMoreVMT: "- Mazāk",
    prematch_EventAvailableAsLive: "Notikums jau ir sācies, dodies uz LIVE.",

    // --------------------- live offer
    live_noRates: "Koeficienti nav pieejami.",
    live_seeOddsInDetail: "Spied te, lai atvērtu likmju piedāvājumu",
    live_EventHasEnded: "Notikums jau ir beidzies.",
    live_OtherEventsBtn: "Citi notikumi",
    live_TabOdds: "Koeficienti",
    live_TabMatchTracker: "Match Tracker",
    live_TabMatchTrackerStats: "Statistika",
    live_TabVideo: "Video",
    live_NoEvents: "Nav aktīvu notikumu.",
    live_BaseballCurrentHalfInningStat: "Notiekošā Pus-Īninga statistika",
    live_AmFootballAttackTeamStat: "Uzbrūkošās komandas statistika",
    live_TimelineTitle: "MAČA LAIKA-JOSLA",
    live_TimelineDesktopTitle: "Notikumi mačā",
    live_ScoreMainScoreTitle: "Rezultāts",
    live_OddBelowName: "Zem",
    live_Favorites: "Favorīti",
    live_NoFavorites: "Nav atzīmēti favorīti.",

    live_WarrantyInfo: "Sniegtajiem laikiem un statistiskajai informācijai ir tikai informatīvs nolūks. SIA Joker Ltd zīmols SynotTip negarantē norādītās informācijas aktualitāti un precizitāti (piem., tekošos rezultātus). Šo informāciju nevar izmantot kā sūdzības pamatu.",

    // ------------------------------ desktop live
    desktopLive_OpenEvents: "Notikumi",
    desktopLive_FavoriteEvents: "Favorīti",
    desktopLive_NoFavoriteEvents: "Favorīti nav atzīmēti. To var izdarīt, starta lapas kreisajā pusē noklikšķinot zvaigznes simbolu pie notikuma.",

    //--------------------- coupon

    coupon_commonError: "Kupons satur kļūdainas prognozes.",

    coupon_LoginForSend: "Ielogojies, lai veiktu likmi",
    coupon_UpdatingSystem: "atjaunina ...",
    coupon_CouponGeneralError: "Kļūda",
    coupon_CouponExpectedNotSystemError: "Sistēmas kļūda, izdzēs notikumus un mēģini vēlreiz",
    coupon_CopyGeneralError: "Kļūda kopējot kuponu",
    coupon_StakeInputError: "Likmes lielums nav derīgs",
    coupon_TicketListCombination: "KOMBINĀCIJA",
    coupon_TicketListStake: "LIKME",
    coupon_TicketListRate: "KOEFICIENTS",
    coupon_TicketListPotentialWin: "IESPĒJAMAIS LAIMESTS",
    coupon_SystemSwitchLabel: "SISTĒMA",

    coupon_HeaderSystemCouponSetting: "Sistēmas likmes iestatījumi",
    coupon_StakeTypeCoupon: "KUPONS",
    coupon_StakeTypeSystem: "SISTĒMA",

    coupon_SummaryPricePotential: "Iespējamais laimests",
    coupon_Stake: "Likme",
    coupon_MaxStake: "Maksimālā likme",
    coupon_TotalRate: "Kopējais koeficients",
    coupon_StakeForOneTicketInSystem: "Summa par vienu likmi sistēmā",
    coupon_AverageRate: "Vidējais koeficients",

    coupon_SentSuccessMessage: "Paldies, likme ir veikta.",
    coupon_SentRejectMessage: "Jūsu likme ir noraidīta",
    coupon_CopyTicket: "Kopēt kuponu",
    coupon_NewTicket: "Jauns kupons",

    coupon_evaluateBtn: "Atjaunot",
    coupon_acceptRateChangeBtn: "Piekrītu",
    coupon_sendToPay: "Apstiprināt",

    coupon_liveAcceptHigerRate: "Apstiprināt augstāku koeficientu",
    coupon_liveAcceptAllRates: "Apstiprināt jebkādas koeficienta izmaiņas",
    coupon_liveHint_Question: "Rekomendējamā summa Jūsu likmei ir {value}. Vai piekrītat?",
    coupon_liveHint_Yes: "Jā",
    coupon_liveHint_No: "Nē",

    coupon_TypePrematch: "Sports",
    coupon_TypeLive: "Live",

    coupon_OddTitle: "Likme",

    coupon_AddPublicLinkToChat: "", //not used

    // -------------------- ticket
    ticket_TicketTabLabel: "Kupons",
    ticket_BettingTicket: "Kupons",
    ticket_SelectionCount: "Prognožu skaits",
    ticket_StakeTypeAll: "KUPONS",
    ticket_StakeTypeUnit: "KOMBI",
    ticket_StakeTypeTotal: "SISTĒMA",
    ticket_OddTitle: "Likme",
    ticket_BankerTitle: "Baņķieris",
    ticket_HasErrors: "Kuponā ir kļūdas",
    ticket_TicketTypeSimple: "Vienk./Komb.", //--Simple
    ticket_TicketTypeSystem: "Sistēma",  //--System
    ticket_TicketTypeVGSplit: "-",
    ticket_TicketTypeVGCombi: "-",
    ticket_EvalTypeLost: "Zaudēts",
    ticket_EvalTypeWin: "Uzvarēts",
    ticket_EvalTypeCancelledWithMP: "Atcelts",
    ticket_EvalTypeCancelled: "Atcelts",
    ticket_EvalTypeCashout: "Cashout pieņemts ",
    ticket_NoTips: "Jūsu kuponā nav prognožu.",
    ticket_Ticket: 'Kupons',
    ticket_TicketStateSettled: "Novērtēts",
    ticket_TicketStateStorno: "Atcelts",
    ticket_TicketStateStornoBySystem: "Sistēmas atcelts",
    ticket_TicketStateStornoByMts: "Atcelts",
    ticket_TicketStateCommonAccepting: "Apstrāde",
    ticket_TicketStateCommonAccepted: "Pieņemts",
    ticket_Login: "Ielogojies, lai apskatītu kuponu.",
    ticket_Calculations: "Kombināciju saraksts",
    ticket_NotFound: "Kupons nav atrasts",
    ticket_TicketOfNumberNotFound: "Kupona ar šādu numuru nav atrasts",
    ticket_Group: "Grupa",
    ticket_CashoutTab: "Cashout",
    ticket_PrepareTicket: "Sagatavot",
    ticket_SelectionResult: "Rezultāts",

    ticket_ReuseOddsTicketBtn: "Pievienot jaunā kuponā",
    ticket_ReuseOddsGeneralError: "Prognozes neizdevās pievienot, mēģiniet vēlreiz vēlāk.",
    ticket_ReuseOddsNotAllAddedError: "Dažas prognozes nevar pievienot kuponā, jo tās vairs nav aktīvas.",

    //my-tickets
    myTickets_NoTicket: 'Nav kupona',
    myTickets_Login: "Ielogojies, lai apskatītu kuponus.",
    myTickets_ColumnPotentialPrice: 'Ie.Laim.',
    myTickets_TypeSports: "SB",
    myTickets_TypeVirtualGames: "VG",

    //Mobile App advert
    mobileAppAdvert_title: "Totalizatora mobilā aplikācija",

    // ---------------------- bet detail
    bet_TicketIdTitle: "Kupona ID",
    bet_TicketStateTitle: "Statuss",
    bet_TicketReasonTitle: "Iemesls",
    bet_TicketDatePaid: "Apmaksas datums",
    bet_System: "Sistēma",
    bet_Stake: "Likme",
    bet_TotalRate: "Kopējais koeficients",
    bet_PotentialPrice: "Iespējamais laimests",
    bet_FinalWin: "Galējais laimests",
    bet_ToPayout: "Tiks izmaksāts",
    bet_TicketType: "Kupona tips",
    bet_BetType: "Likmes tips",
    bet_CanBeCancelledUntil: "Kupons var tikt atcelts līdz:",
    bet_Channel: "Kanāls",
    bet_Match: "Mačs",
    bet_Tip: "Izvēlne",
    bet_TipWinTip: "Prognoze",
    bet_TipTicketDetail: "Prognoze",
    bet_Sum: "Summa", // kde sa používa?
    bet_PossibleWinFrom: "Iespējamais laimests no",
    bet_PossibleWinTo: "Iespējamais laimests līdz",
    bet_Errors: 'Kļūdas',
    bet_HandlingFee: "Komisijas maksa",
    bet_ProductFee: "Produkta maksa",// kde sa používa?
    bet_ProductName: "Produkts",
    bet_OddsRateAdvantage: "Advanced rate",
    bet_RateAdvantageFactor: "Rate advantage",
    bet_Header: "Kupona informācija",
    bet_SuccessfulCashout: "Cash-out veiksmīgi pieņemts",
    bet_ErrorDuringCashout: "Nevar pieņemt cashout",
    bet_ReallyCashoutBetOfValue: "Vai tiešām vēlies pieņemt cashout {value}?",
    bet_FreeTicketSection: "Free ticket",

    bet_PublicLink: "Kupona publiskā saite",
    bet_TransferToCredit: "Transfer to credit",
    bet_TransferToBank: "Transger to bank",

    bet_CopyConfirmYes: "Jā",
    bet_CopyConfirmNo: "Nē",
    bet_CopyConfirmQuestion: "Lai veiktu likmi ar mazāku summu, nepieciešams pārtaisīt kuponu. Vai piekrītat?",
    bet_CopyConfirmTitle: "LIKMES KUPONS",

    bet_AgreeWithLowerAmount: "Vai piekrītat par mazāku summu?",
    bet_Cashout: "Cashout",
    bet_ErrorInTicketListLoad: "Kļūda ielādējot kupona sarakstu",

    bet_CancelUntil: 'Cancel possible until:',
    bet_CancelSuccess: 'Ticket has been cancelled.',
    bet_CancelError_AlreadyCancelled: 'Ticket has been already cancelled',
    bet_CancelError_PeriodOver: 'Time limit for cancellation has passed.',
    bet_CancelError_NotForThisPlayer: 'Ticket is for another player.',
    bet_CancelError_GeneralError: 'Cancellation error',
    bet_CancelBetBtnCancelTitle: "Cancel",

    coupon_CashoutAcceptHigerRate: "Accept higher amount",
    coupon_CashoutAcceptAllRates: "Accept any amount",
    coupon_cashoutButton: "Cashout for {value} ?",


    // ---------------- cashoutList
    cashoutList_ColumnTime: "laiks",
    cashoutList_ColumnStake: "likme",
    cashoutList_ColumnPotentialPrice: "Laimests",
    cashoutList_ColumnSell: "Cashout",
    cashoutList_NoTickets: "Neviens kupons neatbilst cash-out funkcijai.",
    cashoutList_Login: "Ielogojies, lai aplūkotu kuponus, kas derīgi cash-out funckijai.",
    cashoutList_LoadAgain: "Atjaunot",

    //--------------------- betList
    betList_TicketNumber: 'Kupona numurs',
    betList_ColumnTime: "Datums",
    betList_ColumnStake: "Likme",
    betList_ColumnPotentialPrice: "Iesp.laimests",
    betList_ColumnPricePotentialPrice: "Iesp.laimests/laimests",
    betList_ColumnStatus: "Statuss",
    betList_ColumnDetail: "Sīkāk",

    //--------------------- ticketList
    ticketList_TimeFilter_None: "Viss",
    ticketList_TimeFilter_Day: "Diena",
    ticketList_TimeFilter_ThreeDays: "Trīs dienas",
    ticketList_TimeFilter_Week: "Nedēļa",
    ticketList_TimeFilter_TwoWeeks: "2 nedēļas",
    ticketList_TimeFilter_Month: "Mēnesis",

    ticketList_StateFilter_None: "Viss",
    ticketList_StateFilter_Accepted: "Pieņemts",
    ticketList_StateFilter_Win: "Uzvarēts",
    ticketList_StateFilter_Loss: "Zaudēts",
    ticketList_StateFilter_CancelWithHandlingFee: "Atcelts",
    ticketList_StateFilter_Cashout: "Veikts Cash-out",
    ticketList_StateFilter_Storno: "Atcelts",

    ticketList_OfferTypeFilter_None: "Viss",
    ticketList_OfferTypeFilter_Prematch: "Pirmspēles",
    ticketList_OfferTypeFilter_Live: "Live",

    ticketList_Title: "Kupona saraksts",
    ticketList_TimeFilterTitle: "Periods",
    ticketList_StateFilterTitle: "Statuss",
    ticketList_OfferTypeFilterTitle: "Likmes tips",
    ticketList_FilterSubmit: "Parādīt",

    // ------------- ticket detail
    bet_FinalScoreInfo: "Ja spēle noslēgsies pēc papildlaika vai soda sitieniem/metieniem, tas tiks attēlots gala rezultātā.",

    //-------------------- search
    search_FillSomethingInfo: "Ievadi notikumu vai līgas nosaukumu.",
    search_LastSearch: "Pēdējais meklētais:",
    search_ResultEvents: "Notikumi",
    search_ResultLeagues: "Līgas",
    search_NothingFound: "Meklētais notikums vai līga nav atrasti",
    search_InProgress: "Meklē ...",

    // ----------------- offline
    offline_InfoText: "Servera vai tīkla savienojuma pārtraukums",
    offline_TryReconnect: "Mēģina atjaunot savienojumu",

    // ------------ recommended
    recommended_title: "Ieteicams",

    // ----------- mobile QR code
    mobileAppLinkAdvert_Header: "Mobile application",

    // ----------- marketing action
    marketingAction_NoAction: "Akcija nav atrasta",
    marketingAction_Next: "Nākošais",
    marketingAction_Less: "Mazāk",

    //--------- live stream / matchtracker
    liveStream_Opening: "Ielādē ...",
    liveStream_ErrorOpening: "Kļūda ielādējot video.",
    liveStream_NeedToLogin: "Lai vērotu tiešraidi, nepieciešams ielogoties.",
    liveStream_NeedLiveStreamAccess: "Lūdzu, pabeidziet reģistrāciju, lai skatītos tiešraidi.",
    liveStream_NotPlayedNow: "Tiešraide vēl nav pieejama. Sāk ielādi no 1%.",
    liveStream_NotAvailableFormat: "Nevar ielādēt video. Sāk ielādi no 1%.",
    liveStream_TryAgain: "Mēģini vēlreiz",
    liveStream_NoVideoForThisPart: "Nevar ielādēt video.",
    livestream_Login: "Login",

    // -------- live notifications
    liveNotification_ErrorOnUpdate: "Atjauninājuma kļūda",
    liveNotification_Header: "Live paziņojumi",
    liveNotification_AllowRequestText: 'Iestatīt paziņojumus Jūsu ierīces iestatījumos.',
    liveNotification_AllowRequestButton: 'Atļaut',
    liveNotification_NeedAllowInBrowserPermissions: "Jums ir jāaktivizē paziņojumu saņemšanu caur savu pārlūku sadaļā “Vietnes iestatījumi”.",

    //right column
    rightColumn_MyBetsToday: "MANAS LIKMES ŠODIEN",
    rightColumn_NoBetsToday: "Jums šodien nav veiktas likmes",
    rightColumn_LoadAgain: "Atjaunot",

    //find ticket by number
    findTicketByNumber_title: "PĀRBAUDĪT KUPONU",
    findTicketByNumber_InfoText: "Lūdzu ievadiet kupona numuru:",
    findTicketByNumber_buttonSend: "Pārbaudīt",
    findTicketByNumber_Placeholder: "Kupona numurs",

    //chat
    chat_WriteMessagePlaceholder: "your message...",  //chat.yourMessage
    chat_SendMessage: "Send", //chat.sendMessage
    chat_Sending: "Sending ...", //chat.sendingText
    chat_LoginToSendMessage: "Log in to send message...",  //chat.loginToSendMessageInfo
    chat_LoadingMessages: "loading messages ...",
    chat_ErrorLoadingMessagesAgainBtn: "again",  //chat.btnErrorLoadingMessagesAgain
    chat_ErrorLoadingMessage: "unable to load the mesages",  //chat.errorLoadingMessages
    chat_PrivateReply: "Private reply",//chat.privateReply     // cjuba "Uživatelé mi můžou psát privátně",  //chat.acceptAllUsers
    chat_PublicReply: "Public reply",  //chat.publicReply
    chat_AcceptAllUsers: "Accept all users",  //chat.acceptAllUsers
    chat_BlockAllUsers: "Block all users",  //chat.blockAllUsers
    chat_BlockedUser: "Blocked user", //chat.blockedUser
    chat_NonblockedUser: "User not blocked",
    chat_NeedNickname: "Your nickname is not entered. Chat will be available to you after choosing a Nickname in your account settings",
    chat_AnswerForTitle: "Answer for",
    chat_ChatSendMessage_Success: "Message was sent",  //chat.sendMsgOk
    chat_ChatSendMessage_NonExistentReply: "Message on which you are replying is not available",  //chat.sendMsgNoSourceMsg
    chat_ChatSendMessage_PrivateBlocked: "User has blocked private messages",  //chat.sendMsgBlockedPrivate
    chat_ChatSendMessage_TimeConstraintFailed: "You need to wait %1 seconds before sending another message", //chat.sendMsgProtection
    chat_ChatSendMessage_UserBanned: "User is banned",  //chat.sendMsgBanned
    chat_ChatSendMessage_UserNotLogged: "You are not logged in",  //chat.sendMsgNotLogged
    chat_ChatSendMessage_Fail: "Unable to send message",  //chat.sendMsgError

    //saved ticket  // netreba prekladat do SK a CZ, pouziva sa iba v LV
    savedTicket_header: 'Uzmanību',
    savedTicket_thanks: 'Jūsu kupona numurs ir saglabāts.',
    savedTicket_p1: 'Ar šo numuru Jūs varat veikt likmi Synottip likmju pieņemšanas punktos',
    savedTicket_p2: 'Likmes nevar veikt, ja to pieņemšanas laiks ir beidzies',
    savedTicket_warning: 'Veiciet likmi pēc iespējas ātrāk! Koeficientu izmaiņas dēļ, Jūsu likme var netikt pieņemta.',
    savedTicket_identicalBet: 'Identiska likme',

    //calendar
    calendar_startTime: 'starts',
    calendar_event: 'notikums',
    calendar_category: 'līga',

    //upcoming events
    upcomingEvents_label: 'drīzumā',

    //search
    search_searchEventTitle: "Meklēt",

    //favorites
    my_favorites: "Favorīti",

    //live Favorites
    liveFavorites_showMoreDetails: "Parādīt vairāk",
    liveFavorites_hideMoreDetails: 'Rādīt mazāk',

    //OTB
    otb_Switch: 'Ātrā likme',
    otb_InfoText: 'Izvēlies ātro likmi, lai veiktu likmes ar viena klikšķa palīdzību!',
    otb_InfoWarning: "Apstiprini Ātrās likmes iestatījumus.",
    otb_SettingHeader: "Ātrās likmes iestatījumi:",
    otb_FirstPage_Cancel: "Atcelt",
    otb_FirstPage_Confirm: "Apstiprināt",
    otb_TurnOffOTB: "Izslēgt Ātro likmi",
    otb_CancelBetslip: "Atcelt kuponu",
    otb_Sending: "Apstiprinu",

    // rate filter
    rateFilter_Title: "Koeficients",
    rateFilter_From: "No",
    rateFilter_To: "Uz"
};

